import React, { useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../pages/UrlParam.js';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import '../App.css';
import AxiosFetchData from '../pages/AxiosFetchData.js'
import { setValue } from '@syncfusion/ej2-base';
import { DialogFormTemplate } from '../pages/template';
import { getValue } from '@syncfusion/ej2-base';
import { getObject, row } from '@syncfusion/ej2-grids';
import Helper from '../pages/Helper.js';
import Input from '@mui/material/Input';
import MainPrint from '../pages/MainPrint.js';
import { CatchWrapperAsync } from '../utils/catchwrapper.js';

export const useAddInvoicesHook = (id,id2,treegrid) =>{
        const Navigate = useNavigate()
        const [rows, setRows] = useState([]);
        const [description ,setDescription] = useState('');
        const [total ,setTotal] = useState(0);
        const [grandTotal ,setGrandTotal] = useState(0);
        const [persentase ,setPersentase] = useState(0);
        const [persentaseNominal ,setPersentaseNominal] = useState(0);
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('ReturnUrl');
        const [message ,setmessage] = useState('');
        const [retensi ,setRetensi] = useState(0);
        const [retensiFix ,setRetensiFix] = useState(0);
        const [retensiVal ,setRetensiVal] = useState(0);
        const [totalAfterRetention ,setTotalAfterRetention] = useState(0);
        const [totalOrigin ,setTotalOrigin] = useState(0);
        const [InvoiceType ,setInvoiceType] = useState('Percent');
        const [totalDisc ,setTotalDisc] = useState(0);
        const [open, setOpen] =  useState(false);
        const [treedata ,setTreedata] = useState('');
        const [tax ,setTax] = useState(0);
        const [invNo ,setInvNo] = useState('');
        const [customer ,setCustomer] = useState('');
        const [pph ,setPph] = useState(2);
        const [pphValue ,setPphValue] = useState(0);
        const [isCustomer ,setIsCustomer] = useState(true);
        const [roleAccess, setRoleAccess] = useState([]);
        const [invNoCustom, setInvNoCustom] =  useState('');
        const [selectedValue, setSelectedValue] = React.useState('custom');
        const [type, setType] =  useState({});
        const [paymentTermList, setPaymentTermList] = useState([]);
        const [selectedDate, setSelectedDate] =  useState(new Date());
        const [selectedDueDate, setSelectedDueDate] =  useState(new Date());
        const [selectedOptionPaymentTerm ,setSelectedOptionPaymentTerm] = useState('');
    
      //  var treegrid;

        useEffect(() => {
                      const fetchData = async () => {
                        await GetRetention()
                        await GetPaymentTerm();
                        await GetTaskList();
                        await GenerateInvNo();
                        setDescription(new MainPrint().NoteTemplate());
                      }
                      fetchData()
          }, [treegrid]);  
             
          async function  GetPaymentTerm(){
                var response = await AxiosFetchData.get(`GetCustomer/${id}`).refreshToken(Navigate, "invoice");
                if(response){
                  console.log(response.data)
                  if(response.data.length > 0) 
                    {
                        GetPayTerm(response.data[0]);
                    }
                }
                
          }
        
          function GetPayTerm(payment){
                axios.get(`${apiUrl}/api/GetPayTerm`)
                .then((response) => {
                  const transformedOptions = response.data.map((item) => ({
                    label: `${item.name} - ${item.day} day`,
                    value: item.id,
                  }));
                    setPaymentTermList(transformedOptions);
                    setSelectedOptionPaymentTerm({label : `${payment.paymenttermname} - ${payment.paymenttermday} day`, value : payment.paymentermid})
                 
                })
                .catch((error) => {
                  console.error('Error fetching category data:', error);
                });
                 
            }
        
            const GetTaskList = async () => {
                CatchWrapperAsync(async ()=>{
                    const response = await AxiosFetchData.get(`GetQuotationById/${id}/invoice`).refreshToken(Navigate,"invoice",true)
                    if(response){   
        
                    if(response.data.length == 0){
                        setmessage("no items can be found")
                        setType("error")
                        return;
                    }
        
                    //  const rowsWithRowNumbers = response.data.map((row, index) => ({
                    //      ...row,
                    //     rowNumber: index + 1,
                    //  }));
                  
                      setRows(response.data);
                    
                      setRoleAccess(response.roleaccess)
        
                      var totalpo = await AxiosFetchData.get(`IsExistSplitInvoice/${id}`).refreshToken(Navigate,"invoice")
                    
                      setTotalOrigin(totalpo.data.length == 0 ? 0 : totalpo.data.find((val) => val.id == id2).total)
                      
                      setTax(response.data[0].tax)
                     
                      var totaldisc = (response.data.filter(row => row.type == "ex")[0] ?  response.data.filter(row => row.type == "ex")[0].disc : 0) + (response.data.filter(row => row.type == "in")[0] ?  response.data.filter(row => row.type == "in")[0].disc : 0);
                      setTotalDisc(totaldisc);
                  }
                },setmessage,setType)
                // try{
                //   //  const {rowsWithRowNumbers, response}  = await InvoiceHook(id)
                //    const response = await AxiosFetchData.get(`GetQuotationById/${id}/invoice`).refreshToken(Navigate,"invoice")
                //     if(response){   
        
                //     if(response.data.length == 0){
                //         setmessage("no items can be found")
                //         setType("error")
                //         return;
                //     }
        
                //      const rowsWithRowNumbers = response.data.map((row, index) => ({
                //          ...row,
                //         rowNumber: index + 1,
                //      }));
                //    //  console.log(rowsWithRowNumbers)
                //       setRows(rowsWithRowNumbers);
                //      // console.log(rows)
                //       setRoleAccess(response.roleaccess)
        
                //       var totalpo = await AxiosFetchData.get(`IsExistSplitInvoice/${id}`).refreshToken(Navigate,"invoice")
                //      // const {totalpo}= await TotalPoHook(id)
                //       setTotalOrigin(totalpo.data.length == 0 ? 0 : totalpo.data.find((val) => val.id == id2).total)
                      
                //       setTax(response.data[0].tax)
                     
                //       var totaldisc = (response.data.filter(row => row.type == "ex")[0] ?  response.data.filter(row => row.type == "ex")[0].disc : 0) + (response.data.filter(row => row.type == "in")[0] ?  response.data.filter(row => row.type == "in")[0].disc : 0);
                //       setTotalDisc(totaldisc);
                //      // alert(totaldisc)
         
                //   }
                // }catch(e){
                //   setmessage(e.message);
                //   setType("errorlog")
                // }
                
               
            }
         
            const GenerateInvNo = async () => {
                CatchWrapperAsync(async ()=>{
                    const response = await AxiosFetchData.get(`GenerateCodeV3/${id}/${id2}`).refreshToken(Navigate,"invoice")
              
                    setInvNo(response.data);
                    setCustomer(response.data.split('/')[2])
                   
                    if(response.data.split('/')[2] == ''){
                      setIsCustomer(false)
                    }else{
                      setSelectedValue('system')
                    }
                },setmessage,setType)
            //   try{
            //     const response = await AxiosFetchData.get(`GenerateCodeV3/${id}/${id2}`).refreshToken(Navigate,"invoice")
              
            //     setInvNo(response.data);
            //     setCustomer(response.data.split('/')[2])
               
            //     if(response.data.split('/')[2] == ''){
            //       setIsCustomer(false)
            //     }else{
            //       setSelectedValue('system')
            //     }
            //   }catch(e){
            //       setmessage(e.message);
            //       setType("errorlog")
            //   }
            }
           
            const AddParentTask = async () => {
               try{
               
                if(customer == '' && selectedValue == "system"){
                  setmessage("Please complete the invoice no")
                  setType("error")
                  return;
                }
        
                if(selectedValue == "custom"){
                  if(invNoCustom == ''){
                    setmessage("Please complete the invoice no")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('-').length != 2){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
         
                  if(invNoCustom[7]  == "-"){
                   
                  }else{
                    if(invNoCustom[6] == "-"){
        
                    }else{
                        setmessage("Invoice number is not valid")
                        setType("error")
                        return;
                    }
                  }
        
                  if(invNoCustom.split('-')[0].length < 6 || invNoCustom.split('-')[0].length > 7){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
         
                  if(isNaN(invNoCustom.split('-')[0].substring(2,invNoCustom.split('-')[0].length))){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('/').length != 5){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
         
                  if(invNoCustom.split('-')[1].split('/')[0].length != 1){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(isNaN(invNoCustom.split('-')[1].substring(0,1))){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
                  
                  if(invNoCustom.split('/')[1] != "MS"){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('/')[2] == ""){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('/')[3].length != 2){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('/')[4].length != 4){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(isNaN(invNoCustom.split('/')[3])){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(isNaN(invNoCustom.split('/')[4])){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                 
                  if(invNoCustom.split('/')[0].length == 9){
                  
                  }else{
                    if(invNoCustom.split('/')[0].length == 8){
                        
                    }else{
                        setmessage("Invoice number is not valid14")
                        setType("error")
                        return;
                    }
                  }
        
                  if(invNoCustom.substring(0,2) !== "NR"){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
        
                  if(invNoCustom.split('-')[0].substring(2,4) != invNoCustom.split('/')[4].substring(2,4)){
                    setmessage("Invoice number is not valid")
                    setType("error")
                    return;
                  }
                }
              
                if(!isCustomer){
                  var invno = selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom.trim()
                  var inv = await AxiosFetchData.get(`CheckInvoiceNo/${encodeURIComponent(invno)}`).refreshToken(Navigate,"invoice");
               
                  if(inv.data){
                    setmessage(invno.split('-')[0] + " already exist")
                    setType("error")
                    if(selectedValue == "system"){
                      await GenerateInvNo();
                    }
                    return;
                  }
                }
                
                if(persentase == 0){
                  setmessage("Inv(%) cannot be zero")
                  setType("error")
                  return;
                }
        
                if(total != (grandTotal)){
                  setmessage(`Total should be the same as Invoice (${InvoiceType == "Percent" ? `${persentase}%` : `Rp.${Helper.formatAsCurrency(persentase)}`})`)
                  setType("error")
                  return;
                }
         
                var data = {
                  data : JSON.stringify(treegrid.getCurrentViewRecords()),
                  project_id : id,
                 // kode : null,
                  kode : selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom,
                  //tanggal : Helper.GetDateYYYYMMDD(new Date()),
                  tanggal : Helper.GetDateYYYYMMDD(selectedDate),
                  total_all : totalOrigin,
                  //persentase: total,
                  persentase: InvoiceType == "Percent" ? persentase : persentaseNominal,
                  //total : grandTotal * (total /100),
                //  total : total,
                  total : totalAfterRetention,
                  status : "Unpaid",
                  deskripsi  : description,
                  retensiVal : retensiVal,
                  type : InvoiceType,
                  rev : 0,
                  rev_default: 1,
                  split_invoice_id : id2,
                  retention : retensiFix,
                  retention_due_date : Helper.GetDateYYYYMMDD(selectedDueDate),
                  payment_term : selectedOptionPaymentTerm.value,
                  pph : pph,
                  pph_value : pphValue
                }
        
                if(treegrid.getCurrentViewRecords().length > 0){  
                  var response =  await AxiosFetchData.post("CheckInvoiceV3",data).refreshToken(Navigate,"invoice")
                   
                  if(!response.data){
                      setmessage("Invoice is already 100%, can't add more invoices")
                      setType("error")
                      return;
                  }
                  
                  response = await AxiosFetchData.post("AddInvoiceV3",data).refreshToken(Navigate,"invoice");
                  if(response){
                     setmessage(response.data)
                     Navigate(`/${myParam}`)
                      return;
                  }
                }
           
                setmessage("No Data Available");
                setType("error")
                return;
               }catch(e){
                  setmessage(e.message);
                  setType("errorlog")
               }
                
            };
        
            const toolbarOptions = ['Add', 'Edit', 'Delete',   { text: 'Clear', tooltipText: 'Clear', id: 'toolbarfilter', align: 'Right' },{ text: 'Default', tooltipText: 'Default', id: 'toolbarfilter2', align: 'Right' },{ text: 'Preview', tooltipText: 'Preview', id: 'toolbarfilter3', align: 'Right' }];
            const dialogTemplate = (props) => {
                const obj = [props, treegrid];
                return (<DialogFormTemplate {...obj}/>);
            };
            const editOptions = {
                allowAdding: true,
                allowDeleting: true,
                allowEditing: true,
                mode: 'Dialog',
                newRowPosition: 'Child',
                template: dialogTemplate
            };
        
            const actionComplete = (args) => {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    
                    const form = args.form;
                   
                    if (args.requestType === 'beginEdit') {
                    
                    }
                }
         
            };
        
            const actionBegin = (args) => {
             
                if (args.requestType === 'save') {
                     
                }
        
                if ((args.requestType === 'add')) {
                    setValue('data.po_detail_id',Math.random().toString().split('.')[1], args);
                    setValue('data.type',"new", args);
                }
        
                if ((args.requestType === 'delete')) {
                 
                }
            };
        
            function  rowDrop(args) {
              if (args.dropPosition == 'middleSegment' || Object.keys( args.dropPosition).length == 0) {
                args.cancel = true;
                treegrid.reorderRows([args.fromIndex], args.dropIndex, 'above');
             }
            }
            const selectionSettings = { type: 'Multiple' };
        
            const TotalTemplate = (props) => {
              if (getObject('price', props) != null && getObject('newqty', props) != null) {
                   return Helper.formatAsCurrency((getObject('price', props) * getObject('newqty', props)));
                }
                return null;
             
           };
        
           const priceTemplate = (field, data, column) => {
            if (getValue('price', data) != null) {
              return  Helper.formatAsCurrency(getValue('price', data));
            }
            return null;
          };
        
           const customAggregateFn = (row) => {
               const sampleData = getObject('result', row);
               //console.log(sampleData)
               let data = 0;
               if(sampleData){
                sampleData.filter((item) => {
                  if(getObject('price', item) && getObject('newqty', item)){
                      data += getObject('price', item) * getObject('newqty', item);
                  }
              });
              }
              
              setGrandTotal(data)
              return data;
           };
           const custom1 = (props) => {
            return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total :</td><td>{(Helper.formatAsCurrency(getObject('Custom', props)))}</td></tr></table>)
             //  return (<span>Total :  {(Helper.formatAsCurrency(getObject('Custom', props)))}</span>);
           };
        
           const custom =   (props) => {
            return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>inv{InvoiceType=="Percent" ? "(" + persentase + '%)' : ''} :</td><td>{Helper.formatAsCurrency(total)}</td></tr></table>)
            //return (<span>inv({persentase}%) :  {Helper.formatAsCurrency(total)}</span>);
              
           };
        
           const custom2 =  (props) => {
            setRetensiVal(totalOrigin * (retensi / 100));
             //console.log(retensi);
            return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Retention({retensi}%) :</td><td>{Helper.formatAsCurrency(totalOrigin * (retensi / 100))}</td></tr></table>)
             
           };
        
           
           const custom3 =    (props) => {
            setTotalAfterRetention(total - (totalOrigin * (retensi / 100)));
            return (<table border="0" width={"100%"}><tr><td  style={{width:100, textAlign:'right'}}>Grand Total:</td><td >{Helper.formatAsCurrency(total - (totalOrigin * (retensi / 100)))}</td></tr></table>)
           };
        
           const custom4 = (props) => {
              return (<table border="0" width={"100%"}><tr><td style={{width:100, textAlign:'right'}}>Total Project :</td><td>{Helper.formatAsCurrency(totalOrigin)}</td></tr></table>)
           };
        
           const custom5 =   (props) => {
            return (<table border="0" width={"100%"}><tr><td colSpan={2}>&nbsp;</td></tr></table>)
           };
        
        async function handleTotal(data){
          if(!data){
           data = 0;
          }
        
          var index = 0;
          if(data.toString().length > (((data * 1).toString())).length){
            index = data.toString().length - (((data * 1).toString())).length
          }
        
          data = data.toString().substring(index)
           
        
         if(parseFloat(data) > 100 && InvoiceType == 'Percent'){
          setmessage("must be smaller than 100%")
          setType("error")
          return;
         }
         
         setPersentase(data)
          
           const response = await AxiosFetchData.get(`GetINVV3/${id}/${data}/${totalOrigin}/${InvoiceType}/${id2}`).refreshToken(Navigate,"invoice");
          //const response = await AxiosFetchData.get(`GetINVV3/${id}/${data}/${totalOrigin}/${InvoiceType}/0/${id2}`).refreshToken(Navigate);
          if(response){
            
            setTotal(response.data.value);
             
             if(InvoiceType == "Nominal"){
            
                setPersentaseNominal(response.data.persentase);
                if(response.data.persentase > 100 && InvoiceType == 'Nominal'){
                  setmessage("must be smaller than 100%")
                  setType("error")
                  setPersentase(0)
                  setTotal(0)
                  return;
              }
             }
             
            if(data == 100 || ( response.data.persentase && ( response.data.persentase == 100))){
                setRetensi(retensiFix)
            }else{
                setRetensi(0)
                  
            }
               
            //await GetRetention(data, response.data.persentase)
          }
         
        }
        
        const GetRetention = async () => {
            CatchWrapperAsync(async ()=>{
                var response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate,"invoice");
                if(response.data){
                    setRetensiFix(response.data.retensi);
                }
            })
        }
        
        
        const toolbarClick = (args) => {
          if ( args.item.text ==='Clear') {
            
              setRows([])
          }
        
          if ( args.item.text ==='Default') {
             
             GetTaskList();
           }
        
           if (args.item.text ==='Preview') {
             
             document.getElementById('btnPreview').click();
            
         }
          
        };
        
        function handlePreview(){
         
         var data = {
            treeview : treegrid.getCurrentViewRecords(),
            invoice : {
              persentase : persentase,
              total_all :  totalOrigin,
              total : total,
              //kode: invNo,
              kode: selectedValue == "system" ? invNo.split('/')[0] + "/MS/" + customer + "/" + invNo.split('/')[3] + "/" + invNo.split('/')[4] : invNoCustom,
              tax : tax,
              date : selectedDate,
              due_date : selectedDueDate,
              payment_term : selectedOptionPaymentTerm.label,
              pph : pph,
              pph_value : pphValue
            },
            retensi : retensi,
            note:description
          }
        
        setTreedata(JSON.stringify(data))
        setOpen(true);
        }
        
        function handleSelectedPaymentTerm(option){
            var addDay = new MainPrint();
            setSelectedDueDate(addDay.addDays(selectedDate, parseInt(option.label.split(' - ')[1].split(' ')[0].trim())))
            setSelectedOptionPaymentTerm(option)
        }
        
        const settings = { wrapMode: 'Content' };
        
        function SystemInvNo(){
          return (
            <div style={{display: 'flex'}}>
               
            <span style={{fontSize:11, marginTop:10}}>{invNo.split('/')[0]}/MS/&nbsp;</span>
            <input
               type="text"
               value={customer}
               name="inNo"
        
               onChange={(e) => setCustomer(e.target.value)}
             
               className='form-control'
               style={{width:100, height:17, marginTop:10}}
               required
               disabled={isCustomer}
              // style={{margin:5}}
           />&nbsp;
           <span style={{fontSize:11, marginTop:10}}>/ {invNo.split('/')[3]} /{invNo.split('/')[4]} </span>
        </div>
          )
         
        }
        
        function  CustomInvNo(){
          
          
          return(
           
           <Input
              value={invNoCustom}
              fullWidth 
              onChange={(e) => {
                setInvNoCustom(e.target.value)
              }}
              style={{width:"100%", height:20, marginTop:8}}
           />
           
          )
         
        }
        
        const handleChange = (event) => {
          setSelectedValue(event.target.value);
          if(event.target.value === "custom"){
             
            setCustomer('')
          }else{
            setInvNoCustom('')
          }
           
        };
        
        return {message,setmessage,type,setType,AddParentTask,roleAccess,handlePreview,persentase,handleTotal,setInvNoCustom,
            setPersentase,setTotal,setRetensi,InvoiceType,pph,setPph,pphValue,setPphValue,selectedValue,handleChange,
            invNoCustom,invNo,customer,setCustomer,isCustomer,paymentTermList,handleSelectedPaymentTerm,selectedOptionPaymentTerm,
            selectedDate,selectedDueDate,description,setDescription,rows,editOptions,toolbarOptions,settings,priceTemplate,TotalTemplate,customAggregateFn,
            custom1,custom5,custom,custom2,custom3,open,setOpen,treedata,setInvoiceType,setSelectedDate,setSelectedDueDate,treegrid,actionBegin,actionComplete,selectionSettings,toolbarClick,rowDrop
        }
}